import React from "react"
import { storyblokEditable } from "gatsby-source-storyblok"
import classNames from "classnames"
import BeforeContent from "../parts/before_content/before_content.js"
import AfterContent from "../parts/after_content/after_content.js"
import Background from "../parts/background/background.js"
import ColumnItem from "../parts/column_item/column_item.js"

const FlexColumns = ({ blok }) => {
  
  //Remap the columns to an array organized by rows, so we have better control over styling per row.
  let rows_columns = [[]];
  let row_width = 0;

  for(var i = 0; i<blok.columns.length; i++){
    row_width +=  parseInt(blok.columns[i].column_width);
    if(row_width > 100){
      row_width = 0; //reset the width counter
      rows_columns[rows_columns.length] = [blok.columns[i]]; //Add the column to a new row index
    }else{
      const index = (rows_columns.length === 0) ? 0 : rows_columns.length - 1
      rows_columns[index].push(blok.columns[i]); //Add the column to the existing row index
    }
  }

  blok.breakpoint = blok.breakpoint || 'tablet'; 

  return(
    <section
      className={classNames("flex_columns content_block", `breakpoint-${blok.breakpoint}`, {'collapse-top': blok.collapse_top_padding, 'collapse-bottom': blok.collapse_bottom_padding})}
      {...storyblokEditable(blok)}
      key={blok._uid}
    >
      <Background blok={blok.background_settings} />
      <div className="inner">
        <BeforeContent blok={blok.before_content} />
        {typeof blok.columns != "undefined" && (
          <div
            className={ "column_items " + ((blok.reverse_order_mobile === true) ? "column-reverse" : "initial") }
            style={{
              "--col-spacing": `${blok.column_spacing || 40}px`,
              "--row-spacing": `${blok.row_spacing || 55}px`,
              "--col-spacing-m": `${blok.column_spacing_mobile || 40}px`,
              "--row-spacing-m": `${blok.row_spacing_mobile || 20}px`,
              "--vertical-align": blok.content_vertical_align || "flex-start",
              "--horizontal-align": blok.content_horizontal_align || "flex-start",
              "--mobile-direction": (blok.reverse_order_mobile === true)
                ? "column-reverse"
                : "row",
            }}
          >
            {rows_columns.map((row, index) => (
              <div className="row" key={"row_" + index}>
                {row.map(blok => (
                  <ColumnItem key={blok._uid} blok={blok} />
                ))}
              </div>
            ))}
          </div>
        )}
        <AfterContent blok={blok.after_content} />
      </div>
    </section>
  )
}

export default FlexColumns
